/* eslint import/no-unresolved: 0 */
import './country-selector';
import './custom-debug';
import './open-popup';
import './passMatch';
import './service-scroll';
import './tooltip-scroll';
import './controls/fancy-checkbox';
import './time-counter';
import './ocp-button';

// dashboard
import './dashboard/auth/password-strength/password-strength';
import './dashboard/auth/change-language/change-language';
import './dashboard/breadcrumb/breadcrumb';
import './dashboard/device-card/device-card';
import './dashboard/recommendation-banner/recommendation-banner';
import './dashboard/device-settings/device-settings';
import './dashboard/device-rename/device-rename';
import './dashboard/cookie-policy/cookie-policy';
import './dashboard/download-tooltip/download-tooltip';
import './dashboard/welcome-offer/welcome-offer';
import './dashboard/news-tabs/news-tabs';
import './dashboard/prime-page/prime-page';
import './dashboard/cart-iframe/cart-iframe';
import './dashboard/app-price/app-price';
import './dashboard/oo-diskimage-page/oo-diskimage-page';
import './dashboard/store-comparison/store-comparison';
import './dashboard/last-device-details/last-device-details';
import './dashboard/support/support';
import './dashboard/account-details/account-details';
import './dashboard/subscriptions-timeline/subscriptions-timeline';
import './dashboard/crypto-mining/crypto-mining';
import './dashboard/crypto-wallet/crypto-wallet';
import './dashboard/crypto-transactions/crypto-transactions';
import './dashboard/crypto-faq/crypto-faq';
import './dashboard/dwm-assets/dwm-assets';
import './dashboard/dwm-alerts/dwm-alerts';
import './dashboard/cma-disclaimer/cma-disclaimer';
import './dashboard/disclaimer-bar/disclaimer-bar';
import './dashboard/dwm-faq/dwm-faq';
import './dashboard/dwm-card/dwm-card';
import './dashboard/dwm-store/dwm-store';

// header
import './dashboard/header/header';
import './dashboard/header/account-chooser/account-chooser';
import './dashboard/header/user-events/user-events';
import './dashboard/header/user-info/user-info';
import './dashboard/header/language-switcher/language-switcher';
import './dashboard/header/user-settings/user-settings';

// my-account
import './dashboard/my-account/notifications/notifications';
import './dashboard/my-account/profile/profile-details/profile-details';
import './dashboard/my-account/profile/profile-image/profile-image';
import './dashboard/my-account/security/security-password/security-password';
import './dashboard/my-account/security/two-factor-auth/two-factor-auth';
import './dashboard/my-account/security/change-email/change-email';
import './dashboard/my-account/security/login-type/login-type';
import './dashboard/my-account/payment/payment';
import './dashboard/my-account/data-settings/user-data/user-data';
import './dashboard/my-account/data-settings/disable-account/disable-account';
import './dashboard/my-account/data-settings/delete-account/delete-account';

// deployment
import './dashboard/deployment/deploy';
import './dashboard/deployment/choose-device-deployment-wizard/choose-device-deployment-wizard';
import './dashboard/deployment/choose-os-type-deployment-wizard/choose-os-type-deployment-wizard';
import './dashboard/deployment/offline-deployment/offline-deployment';
import './dashboard/deployment/online-deployment/online-deployment';
import './dashboard/deployment/paid-deployment-wizard/paid-deployment-wizard';
import './dashboard/deployment/pc-deployment-wizard/pc-deployment-wizard';
import './dashboard/deployment/pc-email-deployment-success/pc-email-deployment-success';
import './dashboard/deployment/pc-download-deployment-success/pc-download-deployment-success';
import './dashboard/deployment/phone-deployment-wizard/phone-deployment-wizard';
import './dashboard/deployment/phone-email-deployment-success/phone-email-deployment-success';
import './dashboard/deployment/phone-sms-deployment-success/phone-sms-deployment-success';
import './dashboard/deployment/web-app-deployment/web-app-deployment';
import './dashboard/deployment/wizard-generator/deployment-wizard-generator';
import './dashboard/deployment/choose-os-type-wizard/choose-os-type-wizard';
import './dashboard/deployment/deploy-breadcrumb/deploy-breadcrumb';



// WEBPACK FOOTER //
// ./scripts/directives/index.js